import React, { Fragment, lazy, useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import Layout from "../components/Layout";
import {
  DASHBOARD,
  PROFILE,
  USERS,
  TARGET,
  USERPROFILE,
  SKILL_SCORE,
  COMPANY_SETTINGS,
  TEMPLATE,
  CHECKIN,
  VISION,
  CREATE,
  REPORTS,
  // USEREDIT,
  ONBOARDING,
  USERS_GROUP,
  USERS_LIST,
  ROLES_PEMISSION,
  TARGET_LIST,
  SUCCESS_STORIES,
  DEPARTMENTS,
  EXECUTIVE,
  COACHING,
  EDIT,
  OVERVIEW,
  BOARD,
  USER_PROFILE,
  MANUAL,
  RULE,
  PERFORMANCE_REVIEW,
  ARCHIVE,
  CHECKINHIGHLIGHTED,
} from "../constants/routeConstants";
import Footer from "../components/Footer";
import { useRecoilValue } from "recoil";
import { get, isEmpty } from "lodash";
import {
  CompanyDetails,
  loggedInUserDetails,
  permissionsSet,
} from "../recoil/LoggedInUserDetail/selector";
import { COMPANY_ADMIN } from "../constants";
import usePendoInitialization from "../hooks/usePendoInitialization";
import useLogRocketInitialization from "../hooks/useLogRocketInitialization";
import CheckinOverview from "Pages/Checkins/Overview";
import { getUserId, getUserRole, checkArrayLength } from "src/utils";
import { useStyles } from "./styles";
import Document from "Pages/Document/Document";
import { isCompanyAdmin } from "src/utils/externalCoachCondition";

const Dashboard_New = lazy(() => import("../pages/Dashboard_new"));
// old
// const CompanySetup = lazy(() => import("../pages/CompanySetup"));
// const CompanySettings = lazy(() => import("../pages/CompanySettings"));
// new
const CompanySettings = lazy(() =>
  import("../pages/Organization/CompanySetting")
);

const CompanySetup = lazy(() => import("../pages/Organization/CompanySetup"));
const TargetList = lazy(() => import("../pages/TargetList"));
const UserList = lazy(() => import("../pages/User/List"));
const Reports = lazy(() => import("../pages/Reports"));
// const Department = lazy(() => import("Modules/Reports/DepartmentReport"));
// const Coaching = lazy(() => import("Modules/Reports/CoachingReport"));
// const Executive = lazy(() => import("Modules/Reports/ExecutiveSnapshot"));
// const SuccessStoriesReport = lazy(() =>
//   import("Modules/Reports/SuccessStoryKendo")
// );
const UserProfile = lazy(() => import("../pages/User/Profile"));
const PublicVision = lazy(() => import("../pages/PublicVision"));
// const EditUserDetails = lazy(() => import("../pages/User/EditUserDetails"));
const Checkins = lazy(() => import("../pages/Checkins"));
const Onboarding = lazy(() => import("../pages/Onboarding"));
const ErrorPage = lazy(() => import("../components/widgets/ErrorPage"));
const TargetLevelSkillScore = lazy(() =>
  import("../pages/Target/Overview/TargetLevelSkillScore")
);
const TargetCreateEdit = lazy(() => import("../pages/Target/CreateEdit"));
const TargetOverview = lazy(() => import("../pages/Target/Overview"));
const TemplateCreateEdit = lazy(() =>
  import("../pages/Target/Template/CreateEdit")
);

const UserCreateEdit = lazy(() => import("../pages/User/CreateEdit"));

const VisionCreateEdit = lazy(() => import("../pages/Visions/CreateEdit"));
const VisionBoardDetail = lazy(() => import("../pages/Visions/BoardDetail"));
const CreateManualUserGroup = lazy(() =>
  import("../components/createUserGroup/CreateManualUserGroup")
);
const CreateRuleUserGroup = lazy(() =>
  import("../components/createUserGroup/CreateRuleUserGroup")
);

const PeopleOverview = lazy(() =>
  import("Pages/Target/Overview/PeopleOverview")
);

const PrivateRoutes = (props) => {
  const classes = useStyles();
  const companyData = useRecoilValue(CompanyDetails);
  const userData = useRecoilValue(loggedInUserDetails);

  const permissions = useRecoilValue(permissionsSet);
  const createUser = get(permissions, "createUsers", {});
  const userBasedPermissions = get(permissions, "userBasedPermissions", {});
  const userManagement = get(permissions, "userManagement", {});
  const createUserCondition =
    get(createUser, "readAccess", false) ||
    get(createUser, "modifyAccess", false);
  const userBasedCondition =
    get(userBasedPermissions, "writeAccess", false) ||
    get(userBasedPermissions, "modifyAccess", false);
  const userManagementCondition =
    get(userManagement, "writeAccess", false) ||
    get(userManagement, "modifyAccess", false);
  const userProfileCondition =
    createUserCondition || userBasedCondition || userManagementCondition;
  const transcriptReportCondition =
    get(permissions, "transcriptReport.readAccess", false) ||
    get(permissions, "transcriptReport.modifyAccess", false) ||
    get(permissions, "transcriptReport.writeAccess", false) ||
    get(permissions, "transcriptReport.deleteAccess", false);

  const userRolePermission =
    userBasedCondition ||
    get(userBasedPermissions, "readAccess", false) ||
    get(userBasedPermissions, "deleteAccess", false);
  const isCompanySetupCompleted = companyData
    ? companyData.onBoarding === "Completed"
    : null;

  const isUserOnboardingCompleted = userData
    ? userData.onboarding === "Completed"
    : null;

  const isMyTeamEnabled = companyData
    ? get(companyData, "feature.myTeam")
    : null;

  useEffect(() => {
    if (!isEmpty(companyData)) {
      usePendoInitialization(companyData);
    }
  }, [companyData]);

  const userRole = getUserRole();
  const userId = getUserId();

  useEffect(() => {
    if (!isEmpty(companyData) && process.env.REACT_APP_LOGROCKET) {
      useLogRocketInitialization(companyData);
    }
  }, [userId, companyData]);

  if (!isEmpty(companyData) && !isCompanySetupCompleted)
    return (
      <Fragment>
        <div className={classes.root}>
          <Layout isCompanySetupCompleted={isCompanySetupCompleted} />
          <Switch>
            <Route path={DASHBOARD} exact component={CompanySetup} />
            {/* TODO: Set page not found here */}
            <Route path="/*" component={CompanySetup} />
          </Switch>
        </div>
        <Footer />
      </Fragment>
    );
  const checkinsPermission = get(companyData, "feature.checkin", []).filter(
    (res) => res.isEnabled
  );
  if (
    !isEmpty(userData) &&
    !isUserOnboardingCompleted &&
    get(userData, "companyId", "")
  )
    return (
      <Fragment>
        <div className={classes.root}>
          <Layout isCompanySetupCompleted={isUserOnboardingCompleted} />
          <Switch>
            <Route path={`${ONBOARDING}`} exact component={Onboarding} />
            <Route path={`${DASHBOARD}`} component={Onboarding} />
          </Switch>
        </div>
        <Footer />
      </Fragment>
    );

  return (
    <Fragment>
      <div className={classes.root}>
        <Layout isCompanySetupCompleted={isCompanySetupCompleted} />
        <Switch>
          {!isEmpty(companyData) && isCompanySetupCompleted && (
            // <Route path={DASHBOARD} exact component={Dashboard} />
            <Route path={DASHBOARD} exact component={Dashboard_New} />
          )}
          {/* TODO: replace with above */}
          <Route path={DASHBOARD + "new"} exact component={Dashboard_New} />
          {!isEmpty(companyData) &&
            (isMyTeamEnabled || userRole === COMPANY_ADMIN) && (
              <Route path={USERS} exact component={UserList} />
            )}
          {!isEmpty(companyData) &&
            (isMyTeamEnabled || userRole === COMPANY_ADMIN) && (
              <Route
                path={`${USERS}${USERS_LIST}`}
                exact
                component={UserList}
              />
            )}
          {get(createUser, "writeAccess", false) && (
            <Route
              path={`${USERS}${MANUAL}${CREATE}`}
              exact
              component={CreateManualUserGroup}
            />
          )}
          {get(createUser, "writeAccess", false) && (
            <Route
              path={`${USERS}${MANUAL}${EDIT}/:id`}
              exact
              component={CreateManualUserGroup}
            />
          )}

          {get(createUser, "writeAccess", false) && (
            <Route
              path={`${USERS}${RULE}${CREATE}`}
              exact
              component={CreateRuleUserGroup}
            />
          )}
          {get(createUser, "writeAccess", false) && (
            <Route
              path={`${USERS}${RULE}${EDIT}/:id`}
              exact
              component={CreateRuleUserGroup}
            />
          )}

          <Route path={`${USERS}${USERS_GROUP}`} exact component={UserList} />
          {userRolePermission ? (
            <Route
              path={`${USERS}${ROLES_PEMISSION}`}
              exact
              component={UserList}
            />
          ) : null}
          {/* <Route path={TARGET} exact component={TargetList} /> */}
          <Route
            path={`${TARGET}${TARGET_LIST}`}
            exact
            component={TargetList}
          />
          <Route path={`${TARGET}${TEMPLATE}`} exact component={TargetList} />
          {get(permissions, "companyBrandingRules.modifyAccess", false) ||
          get(permissions, "companyBrandingRules.writeAccess", false) ? (
            <Route
              path={`${COMPANY_SETTINGS}/:id`}
              exact
              component={CompanySettings}
            />
          ) : null}
          <Route
            path={`${TARGET}${OVERVIEW}/:id`}
            exact
            component={TargetOverview}
          />
          <Route
            path={`${TARGET}${OVERVIEW}/:id${CHECKINHIGHLIGHTED}/:checkinHighlitedId`}
            exact
            component={TargetOverview}
          />
          {/* <Route
            path={`${TARGET}${DETAIL}/:id`}
            exact
            component={TargetDetail}
          /> */}
          {/* <Route
            path={`${TARGET}${UPDATES}/:id`}
            exact
            component={TargetDetail}
          /> */}
          {/* <Route
            path={`${TARGET}${DETAIL}/:id${OBJECTIVE}/:objId`}
            exact
            component={DetailScreens}
          />
          <Route
            path={`${TARGET}${DETAIL}/:id${CHECKIN}/:checkinId`}
            exact
            component={DetailScreens}
          /> */}
          <Route
            path={`${TARGET}${OVERVIEW}/:id${CHECKIN}/:checkinId`}
            exact
            component={CheckinOverview}
          />
          <Route
            path={`${TARGET}${OVERVIEW}/:id${SKILL_SCORE}`}
            exact
            component={TargetLevelSkillScore}
          />
          {/* <Route
            path={`${TARGET}${DETAIL}/:id${SKILL_SCORE}${INDIVIDUAL_SKILL_SCORE}`}
            exact
            component={IndividualSkillScore}
          /> */}
          <Route
            path={`${TARGET}${OVERVIEW}/:id/:coacheesId`}
            exact
            component={PeopleOverview}
          />
          <Route path={`${PROFILE}/:id`} exact component={UserProfile} />
          <Route path={`${USER_PROFILE}/:id`} exact component={UserProfile} />
          {/* <Route
            path={`${PROFILE}/:id${SKILL_SCORE}`}
            exact
            // component={UserSkillScore}
          />
          <Route
            path={`${USERPROFILE}/:id${SKILL_SCORE}`}
            exact
            // component={UserSkillScore}
          /> */}
          {userProfileCondition && (
            <Route path={`${USERPROFILE}/:id`} exact component={UserProfile} />
          )}
          {/* {userProfileCondition && (
            <Route path={`${USEREDIT}/:id`} exact component={EditUserDetails} />
          )} */}
          {/* <Route path={CREATE_TARGET} exact component={CreateTarget} /> */}
          <Route path={VISION + BOARD} exact component={VisionBoardDetail} />
          {/* <Route path={`${CREATE_TARGET}/:id`} exact component={CreateTarget} />
          <Route path={`${EDIT_TARGET}/:id`} exact component={CreateTarget} /> */}
          <Route
            path={`${TARGET}${CREATE}`}
            exact
            component={TargetCreateEdit}
          />
          <Route
            path={`${TARGET}${EDIT}/:id`}
            exact
            component={TargetCreateEdit}
          />

          <Route
            path={`${TARGET}${TEMPLATE}${CREATE}`}
            exact
            component={TemplateCreateEdit}
          />
          <Route
            path={`${TARGET}${TEMPLATE}${EDIT}/:id`}
            exact
            component={TemplateCreateEdit}
          />
          {get(createUser, "writeAccess", false) && (
            <Route
              path={`${USERS}${EDIT}/:id`}
              exact
              component={UserCreateEdit}
            />
          )}
          {get(createUser, "writeAccess", false) && (
            <Route
              path={`${USERS}${CREATE}`}
              exact
              component={UserCreateEdit}
            />
          )}

          {checkArrayLength(checkinsPermission) && (
            <Route path={CHECKIN + TEMPLATE} exact component={Checkins} />
          )}
          <Route path={VISION + CREATE} exact component={VisionCreateEdit} />
          <Route
            path={`${VISION}${EDIT}/:id`}
            exact
            component={VisionCreateEdit}
          />
          {/* old UI */}
          {/* <Route path={CHECKIN_TEMPLATE} exact component={CheckinTemplate} /> */}
          {/* <Route path={`${VISION}-create`} exact component={CreateVision} /> */}
          {/* <Route path={`${VISION}/create/:id`} exact component={CreateVision} /> */}
          {/* <Route
            path={`${EDIT_TARGET}/:id`}
            exact
            render={() => <CreateTarget isTemplate={true} />}
          /> */}
          {/* <Route
            path={`${TARGET}${CREATE_TEMPLATE}`}
            render={() => <CreateTarget isTemplate={true} isEdit={false} />}
          />
          <Route
            path={`${TARGET}${EDIT_TEMPLATE}/:id`}
            render={() => <CreateTarget isTemplate={true} isEdit={true} />}
          /> */}
          {/* <Route
            path={`${TARGET}${TEMPLATE}${DETAIL}/:id`}
            render={() => <TargetDetail isTemplate={true} />}
          /> */}
          <Route
            path={`${TARGET}${TEMPLATE}${OVERVIEW}/:id`}
            render={() => <TargetOverview isTemplate={true} />}
          />
          {/* <Route
            path={`${TARGET}${PREVIEW}${DETAIL}/:id`}
            render={() => <TargetDetail isPreview={true} />}
          /> */}
          {transcriptReportCondition && (
            <Route
              path={`${REPORTS}${SUCCESS_STORIES}${ARCHIVE}`}
              exact
              component={Reports}
            />
          )}
          {transcriptReportCondition && (
            <Route
              path={`${REPORTS}${PERFORMANCE_REVIEW}${ARCHIVE}`}
              exact
              component={Reports}
            />
          )}
          {transcriptReportCondition && (
            <Route
              path={`${REPORTS}${SUCCESS_STORIES}`}
              exact
              component={Reports}
            />
          )}
          {transcriptReportCondition && (
            <Route
              path={`${REPORTS}${SUCCESS_STORIES}/:id`}
              exact
              component={Reports}
            />
          )}
          {transcriptReportCondition && (
            <Route
              path={`${REPORTS}${PERFORMANCE_REVIEW}`}
              exact
              component={Reports}
            />
          )}
          {transcriptReportCondition && (
            <Route
              path={`${REPORTS}${PERFORMANCE_REVIEW}/:id`}
              exact
              component={Reports}
            />
          )}
          {get(permissions, "departmentReport.readAccess", false) && (
            <Route
              path={`${REPORTS}${DEPARTMENTS}`}
              exact
              component={Reports}
            />
          )}
          {get(permissions, "executiveReport.readAccess", false) && (
            <Route path={`${REPORTS}${EXECUTIVE}`} exact component={Reports} />
          )}
          {get(permissions, "coachingReport.readAccess", false) && (
            <Route path={`${REPORTS}${COACHING}`} exact component={Reports} />
          )}

          {/* <Route path={`${ONBOARDING}`} exact component={Onboarding} /> */}
          {/* <Route
            path={`${VISION}/:visionId`}
            exact
            render={propsData => (
              <PublicVision {...propsData} isPublic={true} />
            )}
          /> */}
          <Route
            path={`${VISION}/:visionId`}
            exact
            render={(propsData) => (
              <PublicVision
                {...propsData}
                initializeAWSConfig={props.initializeAWSConfig}
                publicClient={props.publicClient}
                isPublic={false}
              />
            )}
          />
          {isCompanyAdmin() ? (
            <Route path="/document" render={() => <Document />} />
          ) : null}
          {/* TODO: Set page not found here */}
          {!isEmpty(companyData) && isCompanySetupCompleted && (
            <Route render={() => <ErrorPage errorCode="404" />} />
          )}
        </Switch>
      </div>
      <Footer />
    </Fragment>
  );
};

export default PrivateRoutes;
